import { render, staticRenderFns } from "./DismissalScreenConfig.vue?vue&type=template&id=79cd0fd2&scoped=true"
import script from "./DismissalScreenConfig.vue?vue&type=script&lang=js"
export * from "./DismissalScreenConfig.vue?vue&type=script&lang=js"
import style0 from "./DismissalScreenConfig.vue?vue&type=style&index=0&id=79cd0fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cd0fd2",
  null
  
)

export default component.exports